import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import GoogleMapPicker from "../../components/maps";
import {
  getLocalStorage,
  removeItem,
  resolvePincode,
  setLocalStorage,
} from "../../helpers/utils";
import {
  get,
  post_with_manual_auth,
  get_with_manual_auth,
  update,
  del,
} from "../../helpers/api_helpers";
import { addAddressDetails } from "../../store/UserStore/Address/action";
import { useDispatch } from "react-redux";
import Success from "./success";

const AddressModal = ({
  isOpen,
  setAddressModal,
  // setModalSuccess, // optional (if using success modal)
  successMessage,
  backbuttonTitle,
  setmodal_center, // for login redirect
}) => {
  const dispatch = useDispatch();
  const [city, setCity] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [pin, setPin] = useState("");
  const [addressType, setAddressType] = useState("Home");
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [error, setError] = useState("");
  const [modalsuccess, setModalSuccess] = useState(false);

  const getLocationDetails = async (lat, lng) => {
    const userLocation = await resolvePincode(lat, lng);
    console.log(userLocation);
    setPin(userLocation?.address?.postcode);
    setAddress(userLocation?.display_name);
  };

  const handleMapChange = ({ lat, lng }) => {
    setLatitude(lat);
    setLongitude(lng);
    getLocationDetails(lat, lng);
  };

  const handleSubmit = async (e) => {
    if (!pin || !address) {
      return setError("Please fill all required fields");
    }
    // dispatch(
    //     addAddressDetails({
    //             address: {
    //                // city,
    //               // state: stateVal,
    //               city:'Bengaluru',
    //               state: 'Karnataka',
    //               default_address:true,
    //               is_guest:false,
    //               called_on_signup:true,
    //               pin:pin,
    //               address_type:addressType,
    //               address:address,
    //               latitude:latitude,
    //               longitude:longitude,
    //             },
    //             callback: (res, err) =>{
    //               if(res){
    //                 console.log("Address Saved Api response:Result:",res)
    //                 removeItem("AUTH_DETAILS");
    //                 setAddressModal(false);
    //                 setModalSuccess(true);
    //               }
    //               if (err) {
    //                 const status = err.response?.status;
    //                 console.log("Address Saved Api response:Error:",err)
    //                 setError("Error on Savaing: " + err);
    //               }

    //             }

    //           })
    //         );

    const payload = {
      // city,
      // state: stateVal,
      city: "Bengaluru",
      state: "Karnataka",
      default_address: true,
      is_guest: false,
      called_on_signup: true,
      pin: pin,
      address_type: addressType,
      address: address,
      address_use: "shipping",
      latitude: latitude,
      longitude: longitude,
    };

    // 👉 Call your API here
    const token = getLocalStorage("TEMP_AUTH_DETAILS")?.access_token;
    const temp_auth_dets = getLocalStorage("TEMP_AUTH_DETAILS");
    // console.log("TOKEN:", token);
    try {
      const response = await post_with_manual_auth(
        "/user_address",
        payload,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            skipAuth: true,
            // sktpAuth added to bypass the default auth added in interceptor
          },
        },
      );
      console.log("Address Saved Api response:", response);
      setLocalStorage("AUTH_DETAILS", temp_auth_dets);
      removeItem("TEMP_AUTH_DETAILS");

      const prof_dets = await get_with_manual_auth(
        "/get_profile_details",
        payload, // becomes query params
        {
          headers: {
            Authorization: `Bearer ${token}`,
            skipAuth: true, // bypass interceptor
          },
        },
      );

      console.log("Address Saved Api response:", prof_dets);
      const existing = JSON.parse(localStorage.getItem("AUTH_DETAILS")) || {};
      const updated = {
        ...existing,
        user: {
          email: prof_dets.result.email,
          first_name: prof_dets.result.first_name,
          last_name: null,
          phone: prof_dets.result.phone,
          role: "pet_owner",
        },
      };
      localStorage.setItem("AUTH_DETAILS", JSON.stringify(updated));
      setAddressModal(false);
      setModalSuccess(true);
    } catch (error) {
      // ✅ capture server error response
      console.log(error);
      // console.log(error.response?.status)
      setError("Error on Savaing: " + error);
    }

    // setError("");
    // setAddressModal(false);

    // 👉 next step (choose one)
    // if (setModalSuccess) {
    //   setModalSuccess(true);
    // } else {
    //   setmodal_center(true); // go to login
    // }
  };

  useEffect(() => {
    const location_details = getLocalStorage("LOCATION_DETAILS");
    setPin(location_details?.address?.postcode);
    setAddress(location_details?.display_name);
    setLatitude(location_details?.lat);
    setLongitude(location_details?.lon);
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} centered size="md" scrollable className="signup">
        <div className="modal-header text-center">
          <div className="text-center w-100">
            <h3 className="mb-0">Complete Your Profile</h3>
            <small className="text-muted">Step 3 of 3</small>
          </div>
          <button
            type="button"
            className="close"
            onClick={() => setAddressModal(false)}
          >
            <span>×</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="row">
            {/* City */}
            {/* <div className="col-md-6">
            <input
              className="form-control"
              placeholder="City *"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div> */}

            {/* State */}
            {/* <div className="col-md-6">
            <input
              className="form-control"
              placeholder="State *"
              value={stateVal}
              onChange={(e) => setStateVal(e.target.value)}
            />
          </div> */}

            {/* PIN */}
            <div className="col-md-6 mt-3">
              <input
                className="form-control"
                type="number"
                placeholder="PIN *"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
              />
            </div>

            {/* Address Type */}
            <div className="col-md-6 mt-3">
              <select
                className="form-control"
                value={addressType}
                onChange={(e) => setAddressType(e.target.value)}
              >
                <option value="Home">Home</option>
                <option value="Work">Work</option>
              </select>
            </div>

            {/* Address */}
            <div className="col-md-12 mt-3">
              <textarea
                className="form-control"
                rows="3"
                placeholder="Full Address *"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

            {/* Map */}
            <div className="col-md-12 mt-3">
              <div
                style={{
                  height: "250px",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <GoogleMapPicker
                  initialLat={Number(latitude)}
                  initialLng={Number(longitude)}
                  onChangeLocation={handleMapChange}
                />
              </div>
            </div>
          </div>

          {/* Error */}
          {error && <p className="text-danger mt-3 text-center">{error}</p>}

          {/* Actions */}
          <div className="text-center mt-4">
            {/* <button
            className="btn btn-secondary mr-2"
            onClick={() => setAddressModal(false)}
          >
            Back
          </button> */}

            <button
              className="btn btn-info"
              onClick={handleSubmit}
              disabled={!pin || !address}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
      <Success
        modalsuccess={modalsuccess}
        setModalSuccess={setModalSuccess}
        setmodal_center={setmodal_center}
        successMessage={successMessage}
        backbuttonTitle={backbuttonTitle}
      />
    </>
  );
};

export default AddressModal;
